import { useEffect, useRef } from 'react';

import { SearchResultsFooterReporter, SearchResultsFooterSnapshot } from './SearchResultsFooterState';

interface UseSearchResultsFooterReporterInput extends Omit<SearchResultsFooterSnapshot, 'elapsedMs'> {
    active: boolean;
    report: SearchResultsFooterReporter;
}

export const useSearchResultsFooterReporter = ({
    active,
    loading,
    onPageChange,
    page,
    pageSize,
    report,
    total,
}: UseSearchResultsFooterReporterInput) => {
    const startedAtRef = useRef(0);
    const elapsedMsRef = useRef<number>();
    const wasLoadingRef = useRef(false);

    useEffect(() => {
        if (!active) {
            report(null);
            wasLoadingRef.current = false;
            elapsedMsRef.current = undefined;
            return;
        }

        const now = performance.now();
        if (loading && !wasLoadingRef.current) {
            startedAtRef.current = now;
            elapsedMsRef.current = undefined;
        } else if (!loading && wasLoadingRef.current) {
            elapsedMsRef.current = Math.max(0, now - startedAtRef.current);
        } else if (!loading && elapsedMsRef.current === undefined) {
            elapsedMsRef.current = 0;
        }
        wasLoadingRef.current = loading;

        report({
            elapsedMs: elapsedMsRef.current,
            loading,
            onPageChange,
            page,
            pageSize,
            total,
        });
    }, [active, loading, onPageChange, page, pageSize, report, total]);

    useEffect(() => () => report(null), [report]);
};
